import { render } from "./SearchResultCard.vue?vue&type=template&id=2e9371fc"
import script from "./SearchResultCard.vue?vue&type=script&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__